import React, { useState, useEffect } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView } from '@digital/ui';
import * as ContratoBaseApi from '@app/api/contrato/contratoBase';
import { hasPermission } from '@app/helpers/permissions';
import './custom.css';

const Contrato = () => {
  const [GetAllItems, setGetAllItems] = useState(() => {
    return ContratoBaseApi.getAllContratos;
  });
  return (
    <CrudMasterDetailView
      getAllItems={GetAllItems}
      filterPredicate={(item, value) =>
        item.fornecedor.toLowerCase().includes(value.toLowerCase()) ||
        item.numero.toString().startsWith(value) ||
        item.status.toLowerCase().startsWith(value.toLowerCase()) ||
        (item.situacao ? 'vigente'.startsWith(value.toLowerCase()) : 'vencido'.startsWith(value.toLowerCase())) ||
        (item.objetoResumido != undefined && item.objetoResumido.toLowerCase().startsWith(value.toLowerCase()) == true)
      }
      titleExtractor={item =>
        item.numero.toString() + ' - ' + item.status + ' - ' + (item.situacao ? 'Vigente' : 'Vencido')
      }
      detailTitleExtractor={item =>
        item.numero + ' - ' + item.fornecedor + ' - ' + item.status + ' - ' + (item.situacao ? 'Vigente' : 'Vencido')
      }
      descriptionExtractor={item => item.fornecedor || '---'}>
      <CrudContext.Consumer>{({ selectedItem }) => <CompositeView />}</CrudContext.Consumer>
    </CrudMasterDetailView>
  );
};

export default Contrato;
